import React, { useState, useEffect } from 'react'
import { Col, Row, Image, Badge } from 'react-bootstrap'
import { firestore } from '../../firebase/firebase-utils'

function FullPost(props) {

    const [post, setFullPost] = useState([])
    const [keyword,setkeywords] = useState([])

    const getFullPost = () => {
        var docRef = firestore.collection("technews").doc(props.match.params.id);
        docRef.onSnapshot(function (doc) {
            if (doc.exists) {
                setFullPost(doc.data())
                setkeywords(doc.data().keys)
            } else {
                console.log("No such document!");
            }
        })
    }
    useEffect(() => {
        getFullPost();
        // eslint-disable-next-line
    }, [props])
    
    const getResults = (e)=>{
        props.history.push('/technews/searchresults?topic=' + e.target.innerText)
    }
    return (
        <div className="FullPost">
            {post ?
                <Row className="FullPostChild">
                    <Col sm={12} lg={6}>
                        <div style={{ display: 'flex', alignItems: 'center', margin: '10px 0' }}>
                            {post.authorImg ?
                                <Image style={{ height: '40px', width: '40px', borderRadius: '25px', marginRight: '10px' }} src={post.authorImg} fluid />
                                : ''
                            }

                            <h6>Author: <span style={{ fontFamily: "Righteous", color: 'blue' }}>{post.author}</span></h6>
                        </div>
                        <br />
                        <h5 style={{ fontFamily: "Fredoka One" }}>{post.title}</h5>
                        <p style={{ color: 'gray', fontSize: '12px' }}><i>{post.posttime}</i></p>
                    </Col>
                    <Col sm={12} lg={6}>
                        <Image src={post.img} style={{ background: 'powderblue', padding: '10px', borderRadius: '10px' }} fluid />
                    </Col>
                    <Col style={{ marginTop: '20px' }}>
                        <div dangerouslySetInnerHTML={{ __html: post.content }}></div>
                        <br/>
                        {keyword.map((item)=>(
                        <Badge 
                        style={{marginRight:'10px',marginBottom:'10px',padding:'10px',letterSpacing:'1px',fontFamily:'Kanit',cursor:'pointer'}} 
                        variant="primary" 
                        pill
                        onClick={getResults}
                        key={item}>
                            {item}
                        </Badge>)
                        )}
                    </Col>
                </Row>
                :
                <p style={{ color: 'tomato' }}>No post found with Id: <span style={{ color: '#001a21' }}>{props.match.params.id}</span></p>
            }
        </div>
    )
}

export default FullPost
